module.exports = __webpack_public_path__ + "static/media/t3-img2.0f6cbaa1.png";